export const DATE_TIME = 'ddd, DD MMM YYYY HH:mm:ss';
export const DATE_TIME_WITHOUT_SECOND = 'ddd, DD MMM YYYY HH:mm';
export const DATE_TIME_CSV = 'DD-MMM-YYYY HH:mm:ss';
export const DATE_CSV = 'DD-MMM-YYYY';
export const DATE = 'ddd, DD MMM YYYY';
export const DATE_LONG = 'dddd, DD MMMM YYYY';
export const DATE_SHORT = 'MM-YYYY';
export const TIME = 'HH:mm';
export const TIME_SECONDS = 'HH:mm:ss';
